import { INetworkResult } from '@/coreDomainsModule/networkResult';
import {
  PutUnmanagedBusinessAutoRegisterSettingRequest,
  UnmanagedBusinessAutoRegisterSettingApi,
  UnmanagedBusinessAutoRegisterSettingResult,
} from '../axios/generated/settingManage/api';
import { axiosErrorHandler } from '../axios/axiosError';
import { customAxiosInstance } from '../axios/axiosInstance';
import { IError } from '../interfaces/IError';
import { IUnmanagedBusinessAutoRegisterSettingRepository } from '../interfaces/IUnmanagedBusinessAutoRegisterSettingRepository';

/**
 * 未管理取引の自動登録設定APIを呼び出すRepository
 */
export class UnmanagedBusinessAutoRegisterSettingRepository implements IUnmanagedBusinessAutoRegisterSettingRepository {
  /**
   * 未管理取引の自動登録設定を取得する
   */
  public async get(): Promise<INetworkResult<UnmanagedBusinessAutoRegisterSettingResult, IError>> {
    const axiosInstance = await customAxiosInstance('dbAccess');
    const api = new UnmanagedBusinessAutoRegisterSettingApi(undefined, undefined, axiosInstance);

    try {
      const response = await api.getUnmanagedBusinessAutoRegisterSetting();
      if (response.status === 200) {
        return {
          status: {
            type: 'success',
            data: response.data.result,
          },
        };
      }
      throw new Error('想定外のレスポンス');
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: axiosErrorHandler(error),
        },
      };
    }
  }

  /**
   * 未管理取引の自動登録設定を保存する
   * @param request - 保存リクエスト
   */
  public async put(
    request: PutUnmanagedBusinessAutoRegisterSettingRequest
  ): Promise<INetworkResult<UnmanagedBusinessAutoRegisterSettingResult, IError>> {
    const axiosInstance = await customAxiosInstance('dbAccess');
    const api = new UnmanagedBusinessAutoRegisterSettingApi(undefined, undefined, axiosInstance);

    try {
      const response = await api.putUnmanagedBusinessAutoRegisterSetting(request);
      if (response.status === 200) {
        return {
          status: {
            type: 'success',
            data: response.data.result,
          },
        };
      }
      throw new Error('想定外のレスポンス');
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: axiosErrorHandler(error),
        },
      };
    }
  }
}
